import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            this.initMobileMenu();
            this.initOpinionsSlider();
            this.initFaqAccordion();
            this.initHowItWorksSlider();
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

    initMobileMenu() {
        const parentItems = document.querySelectorAll('.navbar-nav__item--parent');

        parentItems.forEach(item => {
            const link = item.querySelector('.navbar-nav__link');

            link.addEventListener('click', (e) => {
                if (window.innerWidth < 992) {
                    e.preventDefault();
                    item.classList.toggle('open');
                }
            });
        });
    }

    initOpinionsSlider() {
        if ($('.opinions__carousel').length) {
            $('.opinions__carousel').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $('.opinions__nav-prev').on('click', function() {
                $('.opinions__carousel').slick('slickPrev');
            });

            $('.opinions__nav-next').on('click', function() {
                $('.opinions__carousel').slick('slickNext');
            });
        }
    }

    initFaqAccordion() {
        const faqQuestions = document.querySelectorAll('.faq__question');

        faqQuestions.forEach(question => {
            question.addEventListener('click', function() {
                const item = this.closest('.faq__item');
                const isActive = item.classList.contains('faq__item--active');

                document.querySelectorAll('.faq__item').forEach(i => {
                    i.classList.remove('faq__item--active');
                });

                if (!isActive) {
                    item.classList.add('faq__item--active');
                }
            });
        });
    }

    initHowItWorksSlider() {
        if ($('.how-it-works__slider').length) {
            const $slider = $('.how-it-works__slider');

            const initSlider = () => {
                if (window.innerWidth < 768) {
                    if (!$slider.hasClass('slick-initialized')) {
                        $slider.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                            infinite: true,
                            autoplay: false,
                        });

                        $('.how-it-works__arrow-mobile').on('click', function() {
                            $slider.slick('slickNext');
                        });
                    }
                } else {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('unslick');
                    }
                }
            };

            initSlider();

            $(window).on('resize', function() {
                initSlider();
            });
        }
    }

}

new Main();


